import inspect from 'browser-util-inspect';
import { firstValueFrom, Subject } from 'rxjs';
export const asString = (v) => {
    if (typeof v === 'string') {
        return v;
    }
    return inspect(v);
};
export const paddedHex = (v, n) => ('0'.repeat(n - 1) + v.toString(16)).slice(-n);
export const bufferFromSource = (source) => 'buffer' in source ? source.buffer : source;
export const hexString = (arr) => {
    const bytes = Array.from(new Uint8Array(bufferFromSource(arr)));
    return bytes
        .map((b) => paddedHex(b, 2))
        .join('')
        .toUpperCase();
};
export const parseHexString = (value) => {
    if (typeof value !== 'string' || value.length % 2 || !value.match(/^(?:[0-9A-Fa-f]{2})+$/)) {
        throw new TypeError(`${asString(value)} is not a hex string`);
    }
    const nums = new Array(value.length / 2);
    for (let i = 0; i < value.length; i += 2) {
        nums[i / 2] = parseInt(value.slice(i, i + 2), 16);
    }
    return nums;
};
export class LazyExecutor {
    exec;
    constructor(exec) {
        this.exec = exec;
    }
    state = { name: 'init' };
    getSync() {
        switch (this.state.name) {
            case 'init':
            case 'running':
                return undefined;
            case 'done':
                return this.state.value;
            case 'failed':
                throw this.state.error;
        }
    }
    get() {
        if (this.state.name === 'init') {
            const state = { name: 'running', subj: new Subject() };
            this.state = state;
            this.exec()
                .then((value) => {
                if (this.state === state) {
                    this.state = { name: 'done', value };
                    state.subj.next(value);
                    state.subj.complete();
                }
            })
                .catch((error) => {
                if (this.state === state) {
                    state.subj.error(error);
                    this.state = { name: 'failed', error };
                }
            });
        }
        switch (this.state.name) {
            case 'running':
                return firstValueFrom(this.state.subj);
            case 'done':
                return Promise.resolve(this.state.value);
            case 'failed':
                return Promise.reject(this.state.error);
        }
    }
    reset(error) {
        if (this.state.name === 'running') {
            this.state.subj.error(error);
        }
        this.state = { name: 'init' };
    }
}
export const runWithRetries = async ({ exec, onError, maxRetries, }) => {
    let attempt = 0;
    for (;;) {
        try {
            return await exec();
        }
        catch (err) {
            if (onError) {
                await onError({ err, attempt, isMax: attempt === maxRetries });
            }
            ++attempt;
            if (attempt > maxRetries) {
                throw err;
            }
        }
    }
};
export const updateMapWithStableIdentity = (target, newValues) => {
    for (const key of target.keys()) {
        if (!newValues.has(key)) {
            target.delete(key);
        }
    }
    for (const [key, value] of newValues.entries()) {
        const existing = target.get(key);
        if (existing) {
            Object.assign(existing, value);
        }
        else {
            target.set(key, value);
        }
    }
};
//# sourceMappingURL=misc.js.map